
import * as ipxRuntime$qPxdOd8be2Ch5hOq258phoTsAsFTfU02UycK4NLHmzg from '/home/bas/app_8cd291d6-bdea-4f66-b30d-f7ce7ee0b706/node_modules/.pnpm/@nuxt+image@1.10.0_db0@0.3.2_better-sqlite3@12.0.0__ioredis@5.6.1_magicast@0.3.5/node_modules/@nuxt/image/dist/runtime/providers/ipx'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipx",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
}

imageOptions.providers = {
  ['ipx']: { provider: ipxRuntime$qPxdOd8be2Ch5hOq258phoTsAsFTfU02UycK4NLHmzg, defaults: {} }
}
        